module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/039-monaco-02493d3d3c71e570b84188eb1e67ee85.svg";